import { Personnel, Vehicule } from '../../../../shared/types/game';
import { getApiBaseUrl } from '../../../../core/config/api';

/** Obtenir le chemin de l'icône PNG selon le type de bâtiment. */
export const getBuildingIconPath = (buildingType: string): string => {
  switch (buildingType) {
    case 'pompier':
      return '/images/feu.png';
    case 'hopital':
      return '/images/crois.png';
    case 'fdo':
      return '/images/forces-de-lordre.png';
    case 'prison':
      return '/images/prison.png';
    case 'cta':
      return '/images/antenne-cta.png';
    default:
      return '/images/icon-bat.png';
  }
};

/** Configuration des couleurs par type de bâtiment. */
export const getBuildingIconConfig = (
  buildingType: string
): { backgroundColor: string; iconColor: string } => {
  switch (buildingType) {
    case 'pompier':
      return { backgroundColor: '#ef4444', iconColor: '#ffffff' };
    case 'hopital':
      return { backgroundColor: '#ffffff', iconColor: '#ffffff' };
    case 'fdo':
      return { backgroundColor: '#1e40af', iconColor: '#ffffff' };
    case 'prison':
      return { backgroundColor: '#ffffff', iconColor: '#ffffff' };
    case 'cta':
      return { backgroundColor: '#eab308', iconColor: '#ffffff' };
    default:
      return { backgroundColor: '#10b981', iconColor: '#ffffff' };
  }
};

/** Charge le personnel rattaché à un bâtiment (filtre par buildingId). */
export async function fetchBuildingPersonnel(buildingId: number): Promise<Personnel[] | null> {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const response = await fetch(`${getApiBaseUrl(true)}/buildings/personnel`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) return null;
  const data = await response.json();
  if (!data.success || !Array.isArray(data.data)) return null;
  return data.data.filter((p: Personnel) => Number(p.batiment_id) === Number(buildingId));
}

/** Charge les véhicules rattachés à un bâtiment (filtre par buildingId). */
export async function fetchBuildingVehicules(buildingId: number): Promise<Vehicule[] | null> {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const response = await fetch(`${getApiBaseUrl(true)}/buildings/vehicules`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) return null;
  const data = await response.json();
  if (!data.success || !Array.isArray(data.data)) return null;
  return data.data.filter((v: Vehicule) => Number(v.batiment_id) === Number(buildingId));
}
